import { supabase } from './supabase';

// Función para verificar y crear las tablas necesarias
export const checkAndCreateTables = async (): Promise<boolean> => {
  try {
    console.log('Verificando y creando tablas necesarias...');
    
    // Ejecutar la función RPC para crear las tablas
    const { error } = await supabase.rpc('create_transactions_table');
    
    if (error) {
      console.error('Error al crear tablas:', error);
      return false;
    }
    
    console.log('Tablas verificadas y creadas correctamente');
    return true;
  } catch (error) {
    console.error('Error al verificar y crear tablas:', error);
    return false;
  }
};

// Función para verificar la conexión a la base de datos
export const checkDatabaseConnection = async (): Promise<boolean> => {
  try {
    console.log('Verificando conexión a la base de datos...');
    
    // Usar la API de autenticación para verificar la conexión
    const { data, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Error de conexión a la base de datos:', error);
      return false;
    }
    
    console.log('Conexión a la base de datos establecida correctamente');
    return true;
  } catch (error) {
    console.error('Error al verificar conexión a la base de datos:', error);
    return false;
  }
}; 